export default __webpack_public_path__ + "static/media/new_dashboard_calendar_icon.95129a4c.svg";